import { hideAllPoppersInstantly } from "helpers/randomHelpers";
import React, { useEffect, useRef } from "react";
import { useSelector } from "react-redux";
import { selectCurrentUserAttributes } from "slices/authSlice";
import InputEntry from "./InputEntry/InputEntry";
import ListStart from "./ListStart/ListStart";
import RenderedTextEffices from "./RenderedTextEffices/RenderedTextEffices";

const ChannelPage = () => {
  const myId = useSelector((state) => selectCurrentUserAttributes(state).id);
  const textContentRef = useRef();

  useEffect(() => {
    let elem = textContentRef.current;
    if (elem) elem.addEventListener("scroll", hideAllPoppersInstantly);
    return () => {
      elem.removeEventListener("scroll", hideAllPoppersInstantly);
    };
  }, []);

  return (
    <>
      <div
        ref={textContentRef}
        className={`Txt-content 
    `}
      >
        <RenderedTextEffices scrollRef={textContentRef} myId={myId} />
        <ListStart myId={myId} />
      </div>
      <InputEntry textContentRef={textContentRef} />
    </>
  );
};

export default ChannelPage;
